import ReportLineSimple from "@/models/reportLine/ReportLineSimple";
import {assertNumber, isEmpty} from "@/helpers/functions_asi";

export default class ReportLineUpdate {

	public id: string | null = null;
	public text: string | null = null;
	private hourlyRate: number | null = null;
	private dailyLumpSum: number | null = null;
	private amount: number | null = null;

	constructor(reportLine: ReportLineSimple | null = null) {
		this.id = reportLine?.id ?? null;
		this.text = reportLine?.text ?? null;
		this.hourlyRateValue = reportLine?.hourlyRate ?? null;
		this.dailyLumpSumValue = reportLine?.dailyLumpSum ?? null;
		this.amountValue = reportLine?.amount ?? null;
	}

	public set hourlyRateValue(hourlyRate: number | null) {
		this.hourlyRate = assertNumber(hourlyRate);
	}

	public get hourlyRateValue(): number | null {
		return this.hourlyRate;
	}

	public set dailyLumpSumValue(dailyLumpSum: number | null) {
		this.dailyLumpSum = assertNumber(dailyLumpSum);
	}

	public get dailyLumpSumValue(): number | null {
		return this.dailyLumpSum;
	}

	public set amountValue(amount: number | null) {
		this.amount = assertNumber(amount);
	}

	public get amountValue(): number | null {
		return this.amount;
	}

}
